export function ArNote(this: any) {
  return {
    noteId: this.noteId,
    entityId: this.entityId,
    entityType: this.entityType,
    noteText: this.noteText,
    copyToChildCreditors: this.isCopiedToChildCreditors,
    creditorId: this.creditorId
  };
}